import joinclass from 'joinclass';
import React from 'react';
import { connect } from 'react-redux';

import { isHomePage } from '../../utils/pageUtils';
import { ScreenBusUtils } from '../../hooks/useEventBus';
import { scrollTopSmooth } from '../../utils/commonUtils';
import logoBlack from '../../assets/images/logo/logo_black.svg';
import logoWhite from '../../assets/images/logo/logo_white.svg';

export function NavLogo({ pathname, transparent }) {
  const isHome = isHomePage(pathname);

  const handleClick = () => {
    if (!isHome) {
      window.location.reload();
      return;
    }

    scrollTopSmooth();
    ScreenBusUtils.goHome();
  };

  return (
    <span
        className={joinclass('cursor-pointer d-inline-block')}
        onClick={handleClick}
        aria-hidden>
        <img
            src={transparent ? logoWhite : logoBlack}
            alt="Personal Loan Logo"
            width={160}
            height={39}
            style={{
                width: '160px',
                height: '39px',
            }}
        />
    </span>
  );
}

const mapStateToProps = state => ({
  pathname: state.router.location.pathname,
});

export const XNavLogo = connect(mapStateToProps)(NavLogo);
